/* eslint-disable import/no-cycle */
import React from "react";

import moment from "moment";

import { Dialog, DropdownChangeParams } from "primereact";
import ReactPaginate from "react-paginate";
import { Spinner } from "react-bootstrap";

import BackButtom from "../../../../components/backButton";
import DataGrid, { ItemField } from "../../../../components/datagrid";
import TemplateInvoice from "../../../../components/template-invoice";
import ChooseModal from "../../../../components/modals/choose-modal";
import Icons from "../../../../components/icons-helper";
import ButtonRound from "../../../../components/button-action";
import ResumeFiscalNote from "../../../../components/resume";
import ButtonComponent from "../../../../components/button";
import { DocumentCard } from "../../../../components/cards";

import { makeRemoteFiscalNote } from "../../../../../main/factories/usecases/fiscal-note/remote-fiscal-note-factory";

import { InvoiceModel } from "../../../../../domain/models/invoice";
import { FilterModel } from "../../../../../domain/models/enum";
import {
  DocumentsModel,
  DocumentsResponseModel,
} from "../../../../../domain/models/documents";

import { Cards, CardWrapper, IframeStyled, Wrapper } from "./styles";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "../../issue/form/styles";
import { DropdownStyled } from "../../../../components/form-factory/styled";
import { PaginateStyled } from "../../../../components/datagrid/styled";

import { documentType, statusEnum } from "../../../../../utils";
import {
  fetchFiscalNoteDocument,
  cancelFiscalNote,
  displayCancelMessage,
  cancelRecurrenceFiscalNote,
} from "./utils";
import {
  readDocumentAsBase64,
  adjustMimeTypeToPdf,
  showErrorMessage,
  handleClickInfo,
} from "../../../../helpers";
import { settings } from "../../../../../main/configs/settings";

type PageProps = {
  list: DocumentsResponseModel | undefined;
  setParams: any;
  loading?: boolean;
  handleReload: () => void;
};

export const formCurrency = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

export const formCurrencyByCountry = (
  localeCountry: string,
  currencyCountry: string,
): Intl.NumberFormat => {
  const formatedNumber = new Intl.NumberFormat(localeCountry, {
    style: "currency",
    currency: currencyCountry,
    minimumFractionDigits: 2,
  });
  return formatedNumber;
};

const DocumentsListPage: React.FC<PageProps> = ({
  list,
  setParams,
  loading,
  handleReload,
}) => {
  const [selectedDocument, setSelectedDocument] = React.useState<
    DocumentsModel | undefined
  >();
  const [selectedinvoice, setSelectedInvoice] = React.useState<
    InvoiceModel | undefined
  >();
  const [remove, setRemove] = React.useState<DocumentsModel | undefined>();
  const [removeRecurrence, setRemoveRecurrence] = React.useState<DocumentsModel | undefined>();
  const [view, setView] = React.useState<any | undefined>();
  const [filter, setFilter] = React.useState<any | undefined>();

  const [shouldForcePage, setShouldForcePage] = React.useState<boolean>(false);

  const setSelectedInvoiceData = (invoiceData: any): void => {
    setSelectedInvoice({
      ...invoiceData,
      serviceValue: String(invoiceData?.total),
      developerCompany: (invoiceData?.developerCompany as any)?.company,
      currency:
        `${invoiceData?.currency?.name} - (${invoiceData?.currency?.code}) - ${invoiceData?.currency?.symbol} - ${invoiceData?.currency?.id}` as any,
    });
  };

  const setDocumentView = (data: any): void => {
    setView({ doc: data });
  };

  const previewFiscalNote = async (data: any): Promise<void> => {
    try {
      const doc = await fetchFiscalNoteDocument(data?.id);
      const base64String = await readDocumentAsBase64(doc);
      const pdf = adjustMimeTypeToPdf(base64String);
      setView({ doc: data, pdf });
    } catch (error) {
      console.error("Erro ao pré-visualizar a nota fiscal:", error);
    }
  };

  const isInvoice = (data: any): boolean => data?.type === "INVOICE";

  const handleClickView = async (data: any): Promise<void> => {
    if (!isInvoice(data)) {
      await previewFiscalNote(data);
      return;
    }

    setSelectedInvoiceData(data?.invoice);
  };

  const handleClickDownload = async (data: any): Promise<void> => {
    if (!isInvoice(data)) {
      setDocumentView(data);
      return;
    }

    setSelectedInvoiceData(data?.invoice);
  };

  const fields: ItemField[] = [
    {
      title: "Modalidade",
      key: "documentType",
      renderItem: (data: DocumentsModel) =>
        `${documentType.find((el) => el.ENUM === data.type)?.label} ${data?.fiscalNote?.hasRecurrence === true ? " - Recorrente" : ""}` ,
    },
    {
      title: "Número",
      key: "nfseNumber",
      renderItem: (data: DocumentsModel) =>
        data?.fiscalNote?.nfseNumber || data?.invoice?.id,
    },
    {
      title: "Data",
      key: "issuedOn",
      renderItem: (data: DocumentsModel) =>
        moment(data?.issuedOn).format("DD/MM/YYYY"),
    },
    {
      title: "Tomador",
      key: "tomador",
      renderItem: (data: DocumentsModel) =>
        data?.fiscalNote?.taker?.socialReason || data?.invoice?.companyName,
    },
    {
      title: "Status",
      key: "status",
      renderItem: (data: DocumentsModel) =>
        statusEnum.find((el) => el.ENUM === data?.status)?.label,
    },
    {
      title: "Valor",
      key: "name",
      renderItem: (data: DocumentsModel) =>
        formCurrency.format(
          Number(data?.fiscalNote?.noteValue || data?.invoice?.total),
        ),
    },
    {
      title: "Ações",
      key: "actions",
      renderItem: (data: DocumentsModel) => (
        <ContainerButtonActions>
          <ButtonRound
            title="Detalhes"
            backgroundColor={theme.colors.darkBlue}
            onClick={() => handleClickInfo(data)}
            color={theme.colors.blue100}
          >
            <Icons
              height={25}
              width={25}
              name="information"
              color={theme.colors.green}
            />
          </ButtonRound>
          <ButtonRound
            disabled={data?.fiscalNote?.status === "PENDING"}
            backgroundColor={theme.colors.darkBlue}
            title="Visualizar"
            onClick={() => handleClickView(data)}
            color={theme.colors.green}
          >
            <Icons
              height={25}
              width={25}
              name="eye"
              color={theme.colors.green}
            />
          </ButtonRound>
          <ButtonRound
            title="Download"
            disabled={data?.fiscalNote?.status === "PENDING"}
            backgroundColor={theme.colors.darkBlue}
            onClick={() => handleClickDownload(data)}
            color={theme.colors.lightBlue}
          >
            <Icons
              height={20}
              width={20}
              name="download"
              color={theme.colors.primary}
            />
          </ButtonRound>
          <ButtonRound
            title="Cancelar"
            backgroundColor={theme.colors.darkBlue}
            disabled={data.status === "CANCELED"}
            onClick={() => {
              setRemove(data);
            }}
            color={theme.colors.red}
          >
            <Icons
              height={15}
              width={15}
              name="close"
              color={theme.colors.red}
            />
          </ButtonRound>
          {data?.fiscalNote?.hasRecurrence === true ? <ButtonRound
            hasRecurrence="true"
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              setRemoveRecurrence(data);
            }}
            title="Cancelar Recorrência"
            color={theme.colors.red}
          >
            <Icons
              height={15}
              width={15}
              name="cancel-recurrence"
              color={theme.colors.red}
            />
          </ButtonRound> : <></>}
        </ContainerButtonActions>
      ),
    },
  ];

  const handlePage = (e: any): void => {
    setParams((prev: FilterModel) => ({
      ...prev,
      page: e,
    }));

    setShouldForcePage(false);
  };

  const exportNote = async (type: "xml" | "pdf"): Promise<void> => {
    await makeRemoteFiscalNote().exportNote({
      id: view?.doc?.id,
      type,
    });
  };

  const handleError = (error: any): any => {
    showErrorMessage(
      error?.userMessage || error?.detail || "Erro desconhecido",
    );
  };

  const handleCancelNote = async (noteId: number): Promise<void> => {
    try {
      const response = await cancelFiscalNote(noteId);
      handleReload();
      displayCancelMessage(response.status as string);
    } catch (error) {
      handleError(error);
    } finally {
      setRemove(undefined);
    }
  };

  const handleCancelRecurrenceNote = async (noteId: number): Promise<void> => {
    try {
      await cancelRecurrenceFiscalNote(noteId);
      handleReload();
      displayCancelMessage("RECURRENCE" as string);
    } catch (error) {
      handleError(error);
    } finally {
      setRemoveRecurrence(undefined);
    }
  };

  return (
    <Wrapper>
      <BackButtom text="Documentos Emitidos" />
      <CardWrapper>
        <div className="d-flex align-items-center">
          Filtrar por:
          <DropdownStyled
            name="filter"
            disabled={false}
            options={[
              { value: 0, label: "Todos" },
              { value: "FISCAL_NOTE", label: "Nota Fiscal" },
              { value: "INVOICE", label: "Invoice" },
            ]}
            placeholder="Tipo de documento"
            value={filter?.type}
            optionLabel="label"
            optionValue="value"
            style={{ marginBottom: 0, width: "250px", marginLeft: "15px" }}
            onChange={(e: DropdownChangeParams) => {
              setFilter((prev: any) => ({
                ...prev,
                type: e.target.value,
              }));

              setParams((prev: FilterModel) => ({
                ...prev,
                filters: { ...prev?.filters, type: e.target.value },
                page: 0,
              }));

              setShouldForcePage(true);
            }}
          />
          <DropdownStyled
            name="filter"
            disabled={false}
            options={[
              { value: 0, label: "Todos" },
              { value: "WAITING", label: "Processando" },
              { value: "CONCLUDED", label: "Concluída" },
              { value: "CANCELED", label: "Cancelada" },
            ]}
            placeholder="Status"
            value={filter?.status}
            optionLabel="label"
            optionValue="value"
            style={{
              marginBottom: 0,
              width: "250px",
              marginLeft: "15px",
              color: "white",
            }}
            onChange={(e: DropdownChangeParams) => {
              setFilter((prev: any) => ({
                ...prev,
                status: e.target.value,
              }));

              setParams((prev: FilterModel) => ({
                ...prev,
                filters: { ...prev?.filters, status: e.target.value },
                page: 0,
              }));

              setShouldForcePage(true);
            }}
          />
        </div>
      </CardWrapper>
      <Cards>
        {loading && (
          <div className="d-flex justify-content-center">
            <Spinner animation="border" variant="primary" />
          </div>
        )}

        {!loading &&
          list?.content.map((item: any) => (
            <DocumentCard
              key={item.id}
              actions={{
                detail: () => handleClickInfo(item),
                view: () => handleClickView(item),
                download: () => handleClickDownload(item),
                cancel: () => {
                  setRemove(item);
                },
              }}
              docType={documentType.find((el) => el.ENUM === item.type)?.label}
              number={item?.fiscalNote?.nfseNumber || item?.invoice?.id}
              date={moment(item?.issuedOn).format("DD/MM/YYYY")}
              taker={
                item?.fiscalNote?.taker?.socialReason ||
                item?.invoice?.companyName
              }
              status={statusEnum.find((el) => el.ENUM === item?.status)?.label}
              value={
                formCurrency.format(
                  Number(item?.fiscalNote?.noteValue || item?.invoice?.total),
                ) as any
              }
            />
          ))}

        <PaginateStyled>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            pageRangeDisplayed={settings.perPage}
            previousLabel="<"
            nextClassName="next-button"
            prevClassName="prev-button"
            pageCount={list?.totalPages || 0}
            forcePage={shouldForcePage ? 0 : undefined}
            onPageChange={(e: any) => handlePage(e.selected)}
          />
        </PaginateStyled>
      </Cards>

      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={list?.totalPages || 0}
        changePage={handlePage}
        shouldForcePage={shouldForcePage}
      />
      <ChooseModal
        text="Você deseja realmente cancelar esse documento?"
        onConfirm={() => remove?.id && handleCancelNote(remove?.id)}
        onCancel={() => setRemove(undefined)}
        isVisible={!!remove}
        toggleVisibility={() => setRemove(undefined)}
      />
      <ChooseModal
        text="Você deseja realmente cancelar a recorrência?"
        onConfirm={() => removeRecurrence?.id && handleCancelRecurrenceNote(removeRecurrence?.id)}
        onCancel={() => setRemoveRecurrence(undefined)}
        isVisible={!!removeRecurrence}
        toggleVisibility={() => setRemoveRecurrence(undefined)}
      />
      <Dialog
        header="Invoice:"
        visible={!!selectedinvoice}
        style={{ width: window.innerWidth < 479 ? "90vw" : "50vw" }}
        headerStyle={{
          background: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          background: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        footer={null}
        onHide={() => setSelectedInvoice(undefined)}
      >
        <TemplateInvoice
          invoice={selectedinvoice}
          onCancelCallback={() => setSelectedInvoice(undefined)}
        />
      </Dialog>
      <Dialog
        header="Resumo da Nota Fiscal:"
        visible={!!selectedDocument}
        style={{ width: window.innerWidth < 479 ? "90vw" : "50vw" }}
        footer={null}
        onHide={() => setSelectedDocument(undefined)}
      >
        <ResumeFiscalNote fiscalNote={selectedDocument?.fiscalNote} />
      </Dialog>
      <Dialog
        visible={!!view}
        style={{
          width: window.innerWidth < 768 ? "90vw" : "50vw",
          background: theme.colors.darkBlue,
        }}
        headerStyle={{ background: theme.colors.darkBlue }}
        contentStyle={{ background: theme.colors.darkBlue }}
        footer={null}
        onHide={() => setView(undefined)}
      >
        <div>
          {view?.pdf && (
            <IframeStyled title="pdf" src={`${view?.pdf}#toolbar=0`} />
          )}
        </div>
        <div
          className="mt-4 d-flex"
          style={{
            background: theme.colors.darkBlue,
          }}
        >
          <div className="w-50">
            <ButtonComponent
              type="button"
              title="Download XML"
              icon="download"
              color={theme.colors.white}
              backgroundColor={theme.colors.blue400}
              onClick={() => exportNote("xml")}
            />
          </div>
          <div className="ms-2 w-50">
            <ButtonComponent
              type="button"
              title="Download PDF"
              icon="download"
              color={theme.colors.white}
              backgroundColor={theme.colors.blue400}
              onClick={() => exportNote("pdf")}
            />
          </div>
        </div>
      </Dialog>
    </Wrapper>
  );
};
export default DocumentsListPage;
